import { ApolloLink, Operation, NextLink, Observable } from "apollo-link";
import { FetchResult } from "react-apollo";

interface LinkOptions {
  onStart: (operation: Operation) => void;
  onEnd: (operation: Operation) => void;
}

export default class RequestTrackerLink extends ApolloLink {
  public options: LinkOptions;

  constructor(options: LinkOptions) {
    super();
    this.options = options;
  }

  public request(
    operation: Operation,
    forward: NextLink
  ): Observable<FetchResult> {
    return new Observable<FetchResult>(observer => {
      this.options.onStart(operation);
      const subscription = forward(operation).subscribe({
        next: result => {
          this.options.onEnd(operation);
          observer.next(result);
        },
        error: error => {
          this.options.onEnd(operation);
          observer.error(error);
        },
        complete: () => {
          this.options.onEnd(operation);
          observer.complete();
        }
      });
      return () => {
        if (subscription && !subscription.closed) {
          subscription.unsubscribe();
        }
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/requestLink.ts